/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SpecialtiesEnum = {
    JuniorResidentDoctor: 'Junior Resident Doctor',
    PermanentResidentDoctor: 'Permanent Resident Doctor',
    PediatricGpBoardCertifiedHigherDiploma: 'Pediatric (GP - Board Certified - Higher Diploma)',
    OncologyGpBoardCertified: 'Oncology (GP - Board Certified)',
    GeneralSurgeryGpBoardCertifiedHigherDiplomaFrcs: 'General Surgery (GP - Board Certified - Higher Diploma - FRCS)',
    OphthalmologyGpBoardCertifiedHigherDiplomaFrcs: 'Ophthalmology (GP - Board Certified - Higher Diploma - FRCS)',
    ClinicalHematologyGpBoardCertified: 'Clinical Hematology (GP - Board Certified)',
    InternalMedicineGpBoardCertifiedHigherDiploma: 'Internal Medicine (GP - Board Certified - Higher Diploma)',
    RheumatologyGpBoardCertifiedHigherDiploma: 'Rheumatology (GP - Board Certified - Higher Diploma)',
    PulmonologyGpBoardCertifiedHigherDiploma: 'Pulmonology (GP - Board Certified - Higher Diploma)',
    NephrologyGpBoardCertifiedHigherDiploma: 'Nephrology (GP - Board Certified - Higher Diploma)',
    AdultClinicalNonInvasiveCardiologyGpBoardCertified: 'Adult Clinical Non-Invasive Cardiology (GP - Board Certified)',
    NeurologyGpBoardCertified: 'Neurology (GP - Board Certified)',
    NeurophysiologyGpBoardCertifiedHigherDiploma: 'Neurophysiology (GP - Board Certified - Higher Diploma)',
    CommunityMedicineGpBoardCertifiedHigherDiploma: 'Community Medicine (GP - Board Certified - Higher Diploma)',
    FamilyMedicineGpBoardCertifiedHigherDiploma: 'Family Medicine (GP - Board Certified - Higher Diploma)',
    CardiacImagingGpBoardCertifiedHigherDiploma: 'Cardiac Imaging (GP - Board Certified - Higher Diploma)',
    HematopathologyBoardCertified: 'Hematopathology (Board Certified)',
    HistopathologyBoardCertified: 'Histopathology (Board Certified)',
    NeurosurgeryGpBoardCertified: 'Neurosurgery (GP - Board Certified)',
    CardiothoracicSurgeryGpBoardCertified: 'Cardiothoracic surgery (GP - Board Certified)',
    CardiacSurgeryGpBoardCertified: 'Cardiac Surgery (GP - Board Certified)',
    VascularSurgeryGpBoardCertified: 'Vascular surgery (GP - Board Certified)',
    EntGpBoardCertified: 'ENT (GP - Board Certified)',
    PlasticAndReconstructiveSurgeryGpBoardCertified: 'Plastic and Reconstructive Surgery (GP - Board Certified)',
    ObstetricsGynecologyGpBoardCertifiedHigherDiploma: 'Obstetrics & Gynecology (GP - Board Certified - Higher Diploma)',
    PediatricSurgeryGpBoardCertified: 'Pediatric Surgery (GP - Board Certified)',
    OrthopaedicSurgeryGpBoardCertifiedHigherDiploma: 'Orthopaedic Surgery (GP - Board Certified - Higher Diploma)',
    UrologyGpBoardCertified: 'Urology (GP - Board Certified)',
    AnesthesiaAndIntensiveCareGpBoardCertified: 'Anesthesia and Intensive Care (GP - Board Certified)',
    RadiologyGpBoardCertifiedHigherDiploma: 'Radiology (GP - Board Certified - Higher Diploma)',
    RadiotherapyGpBoardCertified: 'Radiotherapy (GP - Board Certified)',
    DermatologyGpBoardCertified: 'Dermatology (GP - Board Certified)',
    PhysicalAndRehabilitationMedicineGpBoardCertifiedHigherDiploma: 'Physical and Rehabilitation Medicine (GP - Board Certified - Higher Diploma)',
    EmergencyMedicineGpBoardCertifiedHigherDiploma: 'Emergency Medicine (GP - Board Certified - Higher Diploma)',
    NuclearMedicineGpBoardCertified: 'Nuclear Medicine (GP - Board Certified)',
    PsychologyGpBoardCertified: 'Psychology (GP - Board Certified)'
} as const;
export type SpecialtiesEnum = typeof SpecialtiesEnum[keyof typeof SpecialtiesEnum];


export function instanceOfSpecialtiesEnum(value: any): boolean {
    return Object.values(SpecialtiesEnum).includes(value);
}

export function SpecialtiesEnumFromJSON(json: any): SpecialtiesEnum {
    return SpecialtiesEnumFromJSONTyped(json, false);
}

export function SpecialtiesEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecialtiesEnum {
    return json as SpecialtiesEnum;
}

export function SpecialtiesEnumToJSON(value?: SpecialtiesEnum | null): any {
    return value as any;
}

